// Catálogo de presets Open Peeps (DiceBear) — data pura, SIN importar dicebear (testeable en Node).
// Cada preset: { id (estable), bucket, options } donde options son opciones Open Peeps deterministas.
// Rediseño 2026-06-12 (pedido del usuario): SOLO humores POSITIVOS/neutros (se quitaron enojados/
// tristes/agresivos) + variedad estética (peinados, colores de pelo, lentes, tonos de piel).
// Abuelos: cabeza claramente masculina (pelo gris corto) o femenina (moño gris); las barbas SOLO van
// en rostros masculinos. NOTA: la barba comparte el trazo negro de la cara → NO se puede teñir de gris
// (facialHairColor no existe en Open Peeps), así que los abuelos con barba quedan "sal y pimienta"
// (pelo plateado + barba oscura) — aceptado por el usuario.
// Enums verificados contra @dicebear/collection. headContrastColor solo colorea 10 heads:
// bangs, cornrows, grayBun, grayMedium, grayShort, mediumBangs2, mohawk, mohawk2, noHair3, short4.

function P(face, head, skin, extra = {}) {
  const o = {
    face: [face], head: [head], skinColor: [skin],
    accessoriesProbability: 0, facialHairProbability: 0, maskProbability: 0,
  }
  if (extra.glasses) { o.accessories = [extra.glasses]; o.accessoriesProbability = 100 }
  if (extra.beard) { o.facialHair = [extra.beard]; o.facialHairProbability = 100 }
  if (extra.hair) { o.headContrastColor = [extra.hair] }
  return o
}

export const OPEN_PEEPS_PRESETS = [
  // ─── SONRIENTES ───
  { id: 'op-smile-01', bucket: 'sonrientes', options: P('smile', 'short1', 'edb98a') },
  { id: 'op-smile-02', bucket: 'sonrientes', options: P('smile', 'hijab', 'd08b5b') },
  { id: 'op-smile-03', bucket: 'sonrientes', options: P('smile', 'bangs', 'ffdbb4', { hair: '2c1b18' }) },
  { id: 'op-smile-04', bucket: 'sonrientes', options: P('smile', 'afro', '694d3d') },
  { id: 'op-smile-05', bucket: 'sonrientes', options: P('smile', 'short4', 'edb98a', { hair: '724133', beard: 'goatee1' }) },
  { id: 'op-smile-06', bucket: 'sonrientes', options: P('smile', 'mediumBangs2', 'ffdbb4', { hair: 'd6b370' }) },
  { id: 'op-smileBig-01', bucket: 'sonrientes', options: P('smileBig', 'mediumStraight', 'ffdbb4') },
  { id: 'op-smileBig-02', bucket: 'sonrientes', options: P('smileBig', 'bun', 'd08b5b') },
  { id: 'op-smileBig-03', bucket: 'sonrientes', options: P('smileBig', 'pomp', 'ae5d29') },
  { id: 'op-smileBig-04', bucket: 'sonrientes', options: P('smileBig', 'longAfro', '694d3d') },
  { id: 'op-smileBig-05', bucket: 'sonrientes', options: P('smileBig', 'cornrows2', '694d3d') },
  { id: 'op-smileLOL-01', bucket: 'sonrientes', options: P('smileLOL', 'longCurly', 'ffdbb4') },
  { id: 'op-smileLOL-02', bucket: 'sonrientes', options: P('smileLOL', 'mohawk2', 'edb98a', { hair: 'c93305' }) },
  { id: 'op-smileLOL-03', bucket: 'sonrientes', options: P('smileLOL', 'buns', 'd08b5b') },
  { id: 'op-smileTeethGap-01', bucket: 'sonrientes', options: P('smileTeethGap', 'buns', 'edb98a') },
  { id: 'op-smileTeethGap-02', bucket: 'sonrientes', options: P('smileTeethGap', 'cornrows', '694d3d', { hair: '2c1b18' }) },
  { id: 'op-eatingHappy-01', bucket: 'sonrientes', options: P('eatingHappy', 'short3', 'edb98a') },
  { id: 'op-eatingHappy-02', bucket: 'sonrientes', options: P('eatingHappy', 'twists', 'd08b5b') },
  { id: 'op-eatingHappy-03', bucket: 'sonrientes', options: P('eatingHappy', 'flatTop', 'ae5d29', { beard: 'moustache2' }) },

  // ─── CARIÑOSOS ───
  { id: 'op-lovingGrin1-01', bucket: 'carinosos', options: P('lovingGrin1', 'long', 'edb98a') },
  { id: 'op-lovingGrin1-02', bucket: 'carinosos', options: P('lovingGrin1', 'hatBeanie', 'ae5d29') },
  { id: 'op-lovingGrin1-03', bucket: 'carinosos', options: P('lovingGrin1', 'bantuKnots', 'd08b5b') },
  { id: 'op-lovingGrin2-01', bucket: 'carinosos', options: P('lovingGrin2', 'twists', '694d3d') },
  { id: 'op-lovingGrin2-02', bucket: 'carinosos', options: P('lovingGrin2', 'short1', 'ffdbb4', { beard: 'moustache1' }) },
  { id: 'op-lovingGrin2-03', bucket: 'carinosos', options: P('lovingGrin2', 'longBangs', 'ffdbb4') },
  { id: 'op-cute-01', bucket: 'carinosos', options: P('cute', 'bangs2', 'ffdbb4') },
  { id: 'op-cute-02', bucket: 'carinosos', options: P('cute', 'bantuKnots', 'd08b5b') },
  { id: 'op-cute-03', bucket: 'carinosos', options: P('cute', 'bun', 'ffdbb4') },
  { id: 'op-cute-04', bucket: 'carinosos', options: P('cute', 'twists2', 'd08b5b') },
  { id: 'op-cute-05', bucket: 'carinosos', options: P('cute', 'mediumBangs3', 'd08b5b') },
  { id: 'op-cheeky-01', bucket: 'carinosos', options: P('cheeky', 'cornrows', '694d3d', { hair: '2c1b18' }) },
  { id: 'op-cheeky-02', bucket: 'carinosos', options: P('cheeky', 'bun', 'edb98a', { glasses: 'sunglasses' }) },

  // ─── GENIALES / LLAMATIVOS ───
  { id: 'op-driven-01', bucket: 'geniales', options: P('driven', 'hatHip', 'd08b5b', { glasses: 'sunglasses2' }) },
  { id: 'op-driven-02', bucket: 'geniales', options: P('driven', 'pomp', 'edb98a', { glasses: 'sunglasses' }) },
  { id: 'op-driven-03', bucket: 'geniales', options: P('driven', 'short5', 'edb98a', { beard: 'full', glasses: 'sunglasses2' }) },
  { id: 'op-calm-01', bucket: 'geniales', options: P('calm', 'turban', 'd08b5b') },
  { id: 'op-calm-02', bucket: 'geniales', options: P('calm', 'noHair1', 'ffdbb4', { glasses: 'glasses2' }) },
  { id: 'op-calm-03', bucket: 'geniales', options: P('calm', 'mediumBangs2', 'edb98a', { hair: '2c1b18' }) },
  { id: 'op-awe-01', bucket: 'geniales', options: P('awe', 'long', 'edb98a') },
  { id: 'op-awe-02', bucket: 'geniales', options: P('awe', 'short1', 'ae5d29', { glasses: 'glasses' }) },
  { id: 'op-awe-03', bucket: 'geniales', options: P('awe', 'mediumBangs', 'd08b5b') },
  { id: 'op-cyclops-01', bucket: 'geniales', options: P('cyclops', 'mohawk', 'd08b5b', { hair: 'c93305' }) },
  { id: 'op-cyclops-02', bucket: 'geniales', options: P('cyclops', 'long', 'ffdbb4') },
  { id: 'op-cheeky-03', bucket: 'geniales', options: P('cheeky', 'hatBeanie', '694d3d') },

  // ─── CLÁSICOS ───
  { id: 'op-calm-04', bucket: 'clasicos', options: P('calm', 'hijab', 'd08b5b') },
  { id: 'op-serious-01', bucket: 'clasicos', options: P('serious', 'flatTop', 'ae5d29', { beard: 'full2' }) },
  { id: 'op-serious-02', bucket: 'clasicos', options: P('serious', 'longCurly', '694d3d') },
  { id: 'op-serious-03', bucket: 'clasicos', options: P('serious', 'short2', 'edb98a', { beard: 'goatee2' }) },
  { id: 'op-explaining-01', bucket: 'clasicos', options: P('explaining', 'short4', 'edb98a', { hair: '724133', glasses: 'glasses4' }) },
  { id: 'op-explaining-02', bucket: 'clasicos', options: P('explaining', 'medium2', 'd08b5b') },
  { id: 'op-explaining-03', bucket: 'clasicos', options: P('explaining', 'bun2', 'edb98a') },
  { id: 'op-smile-07', bucket: 'clasicos', options: P('smile', 'mediumStraight', 'edb98a', { glasses: 'glasses3' }) },
  { id: 'op-calm-05', bucket: 'clasicos', options: P('calm', 'noHair2', 'ae5d29') },
  { id: 'op-smile-08', bucket: 'clasicos', options: P('smile', 'medium3', 'ffdbb4') },

  // ─── ABUELOS / ABUELAS (pelo plateado e8e1e1; barbas SOLO en hombres, quedan oscuras) ───
  { id: 'op-abuelo-01', bucket: 'abuelos', options: P('old', 'grayShort', 'edb98a', { hair: 'e8e1e1', beard: 'full3', glasses: 'glasses' }) },
  { id: 'op-abuelo-02', bucket: 'abuelos', options: P('smile', 'grayShort', 'ffdbb4', { hair: 'e8e1e1', beard: 'moustache5' }) },
  { id: 'op-abuelo-03', bucket: 'abuelos', options: P('calm', 'grayShort', 'edb98a', { hair: 'e8e1e1' }) },
  { id: 'op-abuela-01', bucket: 'abuelos', options: P('calm', 'grayBun', 'edb98a', { hair: 'e8e1e1', glasses: 'glasses2' }) },
  { id: 'op-abuela-02', bucket: 'abuelos', options: P('lovingGrin1', 'grayBun', 'd08b5b', { hair: 'e8e1e1' }) },
  { id: 'op-abuela-03', bucket: 'abuelos', options: P('smile', 'grayMedium', 'ffdbb4', { hair: 'e8e1e1' }) },

  // ─── ASIÁTICOS (aproximación; Open Peeps no tiene etnia: pelo negro 2c1b18 + heads recoloreables) ───
  { id: 'op-asia-01', bucket: 'asiaticos', options: P('smile', 'short4', 'edb98a', { hair: '2c1b18' }) },
  { id: 'op-asia-02', bucket: 'asiaticos', options: P('cute', 'bangs', 'ffdbb4', { hair: '2c1b18' }) },
  { id: 'op-asia-03', bucket: 'asiaticos', options: P('calm', 'mediumBangs2', 'edb98a', { hair: '2c1b18' }) },
  { id: 'op-asia-04', bucket: 'asiaticos', options: P('smileBig', 'grayShort', 'ffdbb4', { hair: '2c1b18', beard: 'goatee1' }) },
]

const _byId = new Map(OPEN_PEEPS_PRESETS.map(p => [p.id, p]))

export function getPresetById(id) {
  return id ? (_byId.get(id) || null) : null
}
